'use client'
import React, { createContext, useContext, useState, ReactNode } from 'react';

// 1. Definimos la interfaz que describe qué datos tendrá nuestro contexto
interface ThemeContextType {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
}

// 2. Creamos el contexto tipado (con un valor inicial por defecto)
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

// 3. Tipamos el parámetro 'children' que recibe el Provider usando ReactNode
interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// 4. Hook personalizado con validación segura de TypeScript
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe usarse dentro de un ThemeProvider');
  }
  return context;
};